import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-organization-settings',
  templateUrl: './btn-organization-settings.component.html',
  styleUrls: ['./btn-organization-settings.component.css']
})
export class BtnOrganizationSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
